import { LINKS } from '@/Module/Core/Constant';
import type { ITeacher } from '@/Module/Teacher/Model/DataModel';
import type { ITeacherInfo } from '@/Module/Teacher/Model/DataModel/ITeacherListByCategory';

export const prepareTeacherUrl = ({ seoUrlSlug }: Pick<ITeacher, 'seoUrlSlug'>) => {
  return LINKS.TEACHER.replace('[id]', String(seoUrlSlug));
};

export const prepareTeacherUrlTeacherPage = ({ name, family }: Pick<ITeacherInfo, 'name' | 'family'>) => {
  const url = `${name ?? ''}-${family ?? ''}`;
  return LINKS.TEACHER.replace('[id]', String(url.replace(/ /g, '-')));
};
